 document.addEventListener('DOMContentLoaded', () => {
    // Função para detectar mobile
    function isMobile() {
      return window.innerWidth <= 768;
    }

    document.querySelectorAll('.quick-add-size').forEach(container => {
      const variants = JSON.parse(container.dataset.variants || '[]');
      const sizeOptionIndex = parseInt(container.dataset.sizeOptionIndex);
      let filteredSize = container.dataset.filteredSize;
      const sizeOptions = container.querySelectorAll('.size-option');
      const addBtn = container.querySelector('.quick-add-button');
      const mobileBtn = container.querySelector('.mobile-add-button');

      // Função alternativa para capturar tamanho da URL via JavaScript
      if (!filteredSize || filteredSize === 'null' || filteredSize === '') {
        const urlParams = new URLSearchParams(window.location.search);
        for (const [key, value] of urlParams) {
          if (key.includes('tamanho') || key.includes('size')) {
            filteredSize = value;
            break;
          }
        }
      }

      let selectedSize = null;
      let selectedVariant = null;

      function findVariantBySize(size) {
        return variants.find(variant => {
          return variant.options[sizeOptionIndex] === size && variant.available;
        });
      }

      function selectSize(targetSize) {
        sizeOptions.forEach(b => b.classList.remove('active'));

        let targetBtn = container.querySelector(`.size-option[data-size="${targetSize}"]`);

        if (!targetBtn) {
          targetBtn = Array.from(sizeOptions).find(btn => {
            return btn.dataset.size === targetSize || 
                   btn.dataset.size.trim() === targetSize.trim() ||
                   btn.textContent.trim() === targetSize.trim();
          });
        }

        if (targetBtn && !targetBtn.disabled) {
          targetBtn.classList.add('active');
          selectedSize = targetBtn.dataset.size;
          const variant = findVariantBySize(selectedSize);
          if (variant) {
            selectedVariant = variant.id;
          }
          return true;
        }
        return false;
      }

      function selectFirstAvailable() {
        const firstAvailableBtn = container.querySelector('.size-option:not(.disabled)');
        if (firstAvailableBtn) {
          firstAvailableBtn.classList.add('active');
          selectedSize = firstAvailableBtn.dataset.size;
          const variant = findVariantBySize(selectedSize);
          if (variant) {
            selectedVariant = variant.id;
          }
        }
      }

      if (filteredSize && filteredSize !== 'null' && filteredSize !== '' && filteredSize !== 'undefined') {
        const sizeSelected = selectSize(filteredSize);
        if (!sizeSelected) {
          selectFirstAvailable();
        }
      } else {
        selectFirstAvailable();
      }

      sizeOptions.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (btn.disabled) return;

          sizeOptions.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          selectedSize = btn.dataset.size;

          const variant = findVariantBySize(selectedSize);
          if (variant) {
            selectedVariant = variant.id;
          }
        });
      });

      if (mobileBtn) {
        mobileBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const productData = {
            id: container.dataset.productId,
            title: container.dataset.productTitle,
            image: container.dataset.productImage,
            variants: variants,
            sizeOptionIndex: sizeOptionIndex,
            filteredSize: filteredSize,
            genderClass: container.classList.contains('girl-theme') ? 'girl-theme' : 'boy-theme'
          };

          if (window.QuickAddModal) {
            window.QuickAddModal.open(productData);
          }
        });
      }

      let isAdding = false;

      function handleAddToCart(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (!selectedVariant || isAdding) {
          return;
        }

        isAdding = true;

        addBtn.disabled = true;
        addBtn.style.pointerEvents = 'none';
        addBtn.textContent = 'Adicionando...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ 
            id: selectedVariant, 
            quantity: 1 
          })
        })
        .then(response => response.json())
        .then(data => {
          addBtn.innerHTML = `
            <span>Adicionado!</span>
            <svg class="cart-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(error => {
          isAdding = false;
          addBtn.disabled = false;
          addBtn.style.pointerEvents = 'auto';
          addBtn.innerHTML = `
            <svg class="cart-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Erro - Tente novamente
          `;
          setTimeout(() => {
            addBtn.innerHTML = `
              <span>Adicionar ao Carrinho</span>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.9211 7.29287C9.31164 7.15483 9.74013 7.35953 9.87817 7.75007C10.1874 8.62497 11.0218 9.25 12.0003 9.25C12.9788 9.25 13.8133 8.62497 14.1225 7.75007C14.2605 7.35953 14.689 7.15483 15.0796 7.29287C15.4701 7.43091 15.6748 7.8594 15.5368 8.24993C15.0223 9.70541 13.6343 10.75 12.0003 10.75C10.3664 10.75 8.97835 9.70541 8.46391 8.24993C8.32587 7.8594 8.53057 7.43091 8.9211 7.29287ZM12.3607 5.5H11.6395C10.0137 5.5 8.93165 5.50267 8.11211 5.60393C7.33378 5.70009 6.97502 5.86728 6.72326 6.07623C6.47149 6.28517 6.24105 6.60698 6.00309 7.35425C5.75254 8.14109 5.5505 9.20417 5.25088 10.8021C4.8309 13.042 4.54933 14.5634 4.49931 15.7093C4.4511 16.8139 4.63619 17.2835 4.89607 17.5966C5.15595 17.9097 5.58337 18.1782 6.67789 18.3344C7.81341 18.4964 9.36063 18.5 11.6395 18.5H12.3607C14.6397 18.5 16.1869 18.4964 17.3224 18.3344C18.4169 18.1782 18.8443 17.9097 19.1042 17.5966C19.3641 17.2835 19.5492 16.8139 19.501 15.7093C19.451 14.5634 19.1694 13.042 18.7494 10.8021C18.4498 9.20417 18.2477 8.14109 17.9972 7.35425C17.7592 6.60698 17.5288 6.28517 17.277 6.07623C17.0253 5.86728 16.6665 5.70009 15.8882 5.60393C15.0686 5.50267 13.9865 5.5 12.3607 5.5ZM5.7653 4.92196C4.65441 5.84393 4.36179 7.40452 3.77657 10.5257C2.95365 14.9146 2.54219 17.1091 3.74181 18.5545C4.94143 20 7.17414 20 11.6395 20H12.3607C16.8261 20 19.0588 20 20.2585 18.5545C21.4581 17.1091 21.0466 14.9146 20.2237 10.5257C19.6385 7.40452 19.3459 5.84393 18.235 4.92196C17.1241 4 15.5363 4 12.3607 4H11.6395C8.46398 4 6.8762 4 5.7653 4.92196Z" fill="#ffffff"></path>
              </svg>
            `;
            isAdding = false;
          }, 2000);
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', handleAddToCart);
      }
    });
  });